
(function (w, d, $, undefined) {
    /**
     * Targets links with the following attributes:
     *   data-ga-track      (selector)
     *   data-ga-category
     *   data-ga-label      (Defaults to the text content)
     *   data-ga-action     (Defaults to 'Klikk')
     * 
     * Example:
     *   <a href="..." data-ga-track data-ga-category="Category">Test</a>
     * Result:
     *   {
     *     eventCategory: "Category",
     *     eventAction: "Klikk",
     *     eventLabel: "Test" 
     *   }
     */
    $('a[data-ga-track]').on('click', function (e) {
        // ?: Is Google Analytics defined?
        var ga = w.ga;
        if (!ga || typeof(ga) !== 'function') {
            // -> Nope! Nothing to do, so escape!
            return;
        }
        // E -> GA is defined! Proceed..

        var url = $(this).attr('href');
        var target = $(this).attr('target') || undefined;

        var hitCallback = undefined;

        // ?: Is target defined?
        if (target === undefined) {
            // -> Prevent default and set hit callback if target is not defined
            e.preventDefault();
            hitCallback = function () {
                d.location = url;
            }
        }
        // E -> Target is defined, most likely "_blank" - so we do not have to override behaviour.

        // Setup payload data for sending to GA
        var category = $(this).attr('data-ga-category');
        var label = $(this).attr('data-ga-label') || $(this).text();
        var action = $(this).attr('data-ga-action') || 'Klikk';

        var payload = {
            hitType: 'event',
            eventCategory: $.trim(category),
            eventAction: $.trim(action),
            eventLabel: $.trim(label),
            hitCallback: hitCallback
        };
        
        // Send of the payload, which will load the link's url when finished
        ga('send', payload);
    });

    /**
     * Targets all forms with the following attributes:
     *   data-ga-track      (selector)
     *   data-ga-category
     *   data-ga-label      
     *   data-ga-action     (Defaults to 'Sendt')
     * 
     * Example:
     *   <form data-ga-track data-ga-category="Form" data-ga-label="Pagename"> ...
     * Result:
     *   {
     *     eventCategory: "Form",
     *     eventAction: "Sendt",
     *     eventLabel: "Pagename" 
     *   }
     */
    $('form[data-ga-track]').on('submit', function(e) {
        // ?: Is Google Analytics defined?
        var ga = w.ga;
        if (!ga || typeof (ga) !== 'function') {
            // -> Nope! Nothing to do, so escape!
            return;
        }
        // E -> GA is defined! Proceed by preventing default action..
        e.preventDefault();

        // Setup payload data for sending to GA
        var category = $(this).attr('data-ga-category');
        var label = $(this).attr('data-ga-label');
        var action = $(this).attr('data-ga-action') || 'Sendt';
        
        var $form = $(this);
        
        var payload = {
            hitType: 'event',
            eventCategory: $.trim(category),
            eventAction: $.trim(action),
            eventLabel: $.trim(label),
            hitCallback: function () {
                $form.off('submit');    // detatch the submit event, so we don't end up in a loop
                $form.find('button[type="submit"]').click();
            }
        };

        // Send of the payload, which will load the link's url when finished
        ga('send', payload);
    });
})(window, document, jQuery)